import { MapConfiguration } from "../../types";

export const ANALYTICS_TRACK_MAP_LOADED = "analytics/trackMapLoaded";
export const ANALYTICS_TRACK_FIND_FLIGHTS = "analytics/trackFindFlights";
export const ANALYTICS_TRACK_FLIGHT_DETAILS = "analytics/trackFlightDetails";
export const ANALYTICS_TRACK_PAGE_VIEW = "analytics/trackPageView";
export const ANALYTICS_TRACK_FLIGHT_DETAILS_PRINT =
  "analytics/trackFlightDetailsPrint";
export const ANALYTICS_TRACK_FLIGHT_LIST_PRINT =
  "analytics/trackFlightListPrint";
export const ANALYTICS_TRACK_FIND_DESTINATIONS =
  "analytics/trackerFindDestinations";
export const ANALYTICS_TRACK_FIND_AIRPORTS_SERVED =
  "analytics/trackerFindAirportServed";
export const ANALYTICS_TRACK_FLIGHT_BOOKING_LINK =
  "analytics/trackFlightBookingLink";

export function trackMapLoaded(map: MapConfiguration) {
  return {
    type: ANALYTICS_TRACK_MAP_LOADED,
    payload: map,
  };
}

export function trackFindFlights(queryTrigger, eventRequestUse) {
  return {
    type: ANALYTICS_TRACK_FIND_FLIGHTS,
    payload: { eventRequestUse, queryTrigger },
  };
}

export function trackFlightDetails(flight) {
  return {
    type: ANALYTICS_TRACK_FLIGHT_DETAILS,
    payload: flight,
  };
}

export function trackPageView(page) {
  return {
    type: ANALYTICS_TRACK_PAGE_VIEW,
    payload: page,
  };
}

export function trackFlightDetailsPrint() {
  return {
    type: ANALYTICS_TRACK_FLIGHT_DETAILS_PRINT,
  };
}

export function trackerFlightListPrint() {
  return {
    type: ANALYTICS_TRACK_FLIGHT_LIST_PRINT,
  };
}

export function trackerFindDestinations(queryTrigger, eventRequestUse) {
  return {
    type: ANALYTICS_TRACK_FIND_DESTINATIONS,
    payload: { eventRequestUse, queryTrigger }
  };
}

export function trackerFindAirportServed(queryTrigger, request) {
  return {
    type: ANALYTICS_TRACK_FIND_AIRPORTS_SERVED,
    payload: { request, queryTrigger }
  };
}

export function trackFlightBookingLink(bookingData) {
  return {
    type: ANALYTICS_TRACK_FLIGHT_BOOKING_LINK,
    payload: bookingData
  };
}
